var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L10 10M1 15.2663V5.26633M13 15.2663C13 16.3709 12.1046 17.2663 11 17.2663H7M13 5.26633C13 4.16176 12.1046 3.26633 11 3.26633H7M1.8906 17.8601L3.8906 19.1934C5.21971 20.0795 7 19.1267 7 17.5293V3.00336C7 1.40597 5.21971 0.453189 3.8906 1.33926L1.8906 2.6726C1.3342 3.04353 1 3.66799 1 4.3367V16.196C1 16.8647 1.3342 17.4891 1.8906 17.8601Z",
    stroke: "#EF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.158b97feb15373894048ea0d97b0c419.svg";
export { ForwardRef as ReactComponent };